import { render } from "./confirmPayDiy.vue?vue&type=template&id=5a2a1207&scoped=true"
import script from "./confirmPayDiy.vue?vue&type=script&lang=js"
export * from "./confirmPayDiy.vue?vue&type=script&lang=js"

import "./confirmPayDiy.vue?vue&type=style&index=0&id=5a2a1207&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2a1207"]])

export default __exports__